import React from 'react'

import medal from '../../../../images/main/medal.svg'
import bootable from '../../../../images/main/booble.svg'
import gal from '../../../../images/main/galien.svg'

import styles from './styles.module.scss'
// import banner from '../../../../images/main/hh.jpg'

const OurIdea = () => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.left}>
        {/* <a className={styles.left_banner} href="https://rating.hh.ru/poll" target="_blank">
          <img src={banner} alt=""/>
        </a> */}
        <p className={styles.about_company}>О компании</p>
        <div className={styles.list}>
          <div className={styles.item}>
            <p className={styles.number}>15</p>
            <p className={styles.text_lg}>
              лет на рынке
            </p>
          </div>
          <div className={styles.item}>
            <p className={styles.number}>1700+</p>
            <p className={styles.text_lg}>
              сотрудников
            </p>
          </div>
          <div className={styles.item}>
            <p className={styles.number}>80</p>
            <p className={styles.text_lg}>
              га территории <br />биотехнопарка
            </p>
          </div>
          <div className={styles.item}>
            <p className={styles.number}>61 000</p>
            <p className={styles.text_lg}>
              м&sup2;&nbsp;производственных <br />мощностей
            </p>
          </div>
        </div>
      </div>
      <div className={styles.right}>
        <div className={styles.right_wrapper}>
          <p className={styles.title}>
            Наши идеи и достижения <br />для спасения жизни <br />и здоровья людей
          </p>
          <p className={styles.title_p1}>
            Generium — научно-производственная компания полного цикла. Наши сотрудники контролируют все этапы
            производства лекарственных препаратов: от создания молекул до промышленного выпуска.
          </p>
          <p className={styles.title_p2}>Мы занимаем лидирующие позиции в орфанном сегменте российского фармацевтического рынка. А новейшее научное оборудование, высокопрофессиональная команда и отлаженные процессы помогают нам добиваться признания и за рубежом.</p>
        </div>
        <div className={styles.information}>
          <div>
            <img src={bootable} alt='icons' />
            <p>Более 60% препаратов компании - из орфанного сегмента</p>
          </div>
          <div>
            <img src={medal} alt='icons' />
            <p>
              В кратчайшие сроки обеспечили масштабирование и промышленный выпуск вакцины от COVID-19
            </p>
          </div>
          <div>
            <img src={gal} alt='icons' />
            <p>
              Премия Галена за разработку инновационного метода диагностики туберкулёза, получившего признание в ВОЗ
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default OurIdea
